import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import ReactHtmlParser from 'react-html-parser';
import _ from 'lodash';

// Components
import { Carousel } from '@zola/zola-ui';
import ConnectedListingDetail from '../../CardListing/ListingDetail/ListingDetail';

// Actions
import {
  getRelatedCardsFromSuite,
  setInitialVariationColor,
  unMountRelatedCards
} from '../../../actions/cardCatalogActions';

// Selectors
import {
  getRelatedCardsFromCurrentSuite,
} from '../../../selectors/cardCatalogSelector';

// Stylesheets
import './RelatedCardsCarousel.less';

export class RelatedCardsCarousel extends Component {
  componentDidMount() {
    const { family, onGetRelatedCardsFromSuite, unMountRelatedCardsFromSuite, fallbackDisplay } = this.props;
    unMountRelatedCardsFromSuite();
    onGetRelatedCardsFromSuite(family).then((data) => {
      if (fallbackDisplay && _.isEmpty(data.payload.relatedCards.suites)) {
        fallbackDisplay();
      }
    });
  }

  componentWillUnmount() {
    const { unMountRelatedCardsFromSuite } = this.props;
    unMountRelatedCardsFromSuite();
  }

  render() {
    const {
      relatedCards,
      lightView,
      isAdminView,
      onSetInitialVariationColor,
      initialVariationColor,
      filterColor,
      family,
      referenceType,
    } = this.props;
    const basePlanningUrl = isAdminView ? '/wedding-planning/admin' : '/wedding-planning';
    const cardTypes = {
      SAVE_THE_DATE: {
        text: 'Save the Dates',
        path: `${basePlanningUrl}/save-the-date/shop`
      },
      INVITATION: {
        text: 'Invitations',
        path: `${basePlanningUrl}/invitations/shop`
      },
      THANK_YOU: {
        text: 'Thank You Cards',
        path: `${basePlanningUrl}/thank-you-cards/shop`
      },
      MENU: {
        text: 'Menus',
        path: `${basePlanningUrl}/menus/shop`
      },
      PROGRAM: {
        text: 'Programs',
        path: `${basePlanningUrl}/programs/shop`
      },
      DETAILS: {
        text: 'Enclosures Cards',
        path: `${basePlanningUrl}/enclosures/shop`
      }
    };
    const gridCarouselSettings = {
      dots: false,
      arrows: true,
      infinite: true,
      swipeToSlide: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      lazyLoad: false,
      useCSS: true,
      useTransform: false,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
          }
        }
      ]
    };

    const carouselSuiteData = relatedCards.length > 0 && relatedCards.map(card => (
      <div className="related-cards-carousel__wrapper" key={card.uuid}>
        <ConnectedListingDetail
          card={card}
          filterColor={filterColor}
          basePlanningUrl={basePlanningUrl}
          onSetInitialVariationColor={onSetInitialVariationColor}
          initialVariationColor={initialVariationColor}
          lightView={lightView}
        />
        {!lightView && (
          <Link to={cardTypes[card.type].path} className="related-cards-carousel__more-link">More {cardTypes[card.type].text} &gt;</Link>
        )}
      </div>
    ));

    const title = {
      invites: `Shop The Full <span class="related-cards-carousel__title--emphasis">${family}</span> Suite`,
      website: `Pair It With Paper Products In <span class="related-cards-carousel__title--emphasis">${family}</span>`
    };

    return (
      <div>
        {carouselSuiteData && (
          <div className="related-cards-carousel__section__inner-wrapper">
            <h3 className="related-cards-carousel__title">{ReactHtmlParser(title[referenceType])}</h3>
            <Carousel content={carouselSuiteData} settings={gridCarouselSettings} className="related-cards-carousel__content" />
          </div>
        )}
      </div>
    );
  }
}

RelatedCardsCarousel.propTypes = {
  unMountRelatedCardsFromSuite: PropTypes.func,
  relatedCards: PropTypes.arrayOf(PropTypes.shape({})),
  onGetRelatedCardsFromSuite: PropTypes.func,
  onSetInitialVariationColor: PropTypes.func,
  initialVariationColor: PropTypes.string,
  family: PropTypes.string,
  lightView: PropTypes.bool,
  isAdminView: PropTypes.bool,
  filterColor: PropTypes.string,
  referenceType: PropTypes.string,
  fallbackDisplay: PropTypes.func,
};

const mapStateToProps = state => ({
  relatedCards: getRelatedCardsFromCurrentSuite(state),
});

const mapDispatchToProps = dispatch => ({
  onGetRelatedCardsFromSuite: (familyName, initialColor) => dispatch(getRelatedCardsFromSuite(familyName, initialColor)),
  unMountRelatedCardsFromSuite: () => dispatch(unMountRelatedCards()),
  onSetInitialVariationColor: color => dispatch(setInitialVariationColor(color)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RelatedCardsCarousel);



// WEBPACK FOOTER //
// ./src/cards/components/common/RelatedCardsCarousel/RelatedCardsCarousel.jsx